import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const ReplyIcon = createIcon({
  displayName: 'ReplyIcon',
  path: [
    <path
      d='M10 9V7.41c0-.89-1.08-1.34-1.71-.71L3.7 11.29a.996.996 0 0 0 0 1.41l4.59 4.59c.63.63 1.71.19 1.71-.7V14.9c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11Z'
      fill='currentColor'
    />
  ],
  defaultProps: defaultProps
})
